"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var InputWithOptions_st_css_1 = require("./InputWithOptions.st.css");
var dropdown_1 = require("../dropdown");
var dropdown_option_1 = require("../dropdown-option");
var input_1 = require("../input");
exports.DataHooks = {
    input: 'input',
    emptyState: 'input-with-options-empty-state',
};
/**
 * InputWithOptions
 */
var InputWithOptions = /** @class */ (function (_super) {
    tslib_1.__extends(InputWithOptions, _super);
    function InputWithOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isEditing = false;
        _this._onSelect = function (option) {
            _this.isEditing = false;
            var _a = _this.props, onSelect = _a.onSelect, onManualInput = _a.onManualInput, inputProps = _a.inputProps;
            if (option) {
                onSelect(option);
            }
            else {
                onManualInput(inputProps.value);
            }
        };
        _this._onKeyDown = function (event) {
            if (!event.key.startsWith('Arrow')) {
                _this.isEditing = true;
            }
            var onKeyDown = _this.props.inputProps.onKeyDown;
            onKeyDown && onKeyDown(event);
        };
        _this._onFocus = function (event) {
            _this.isEditing = false;
            var onFocus = _this.props.inputProps.onFocus;
            onFocus && onFocus(event);
        };
        _this._onBlur = function (event) {
            if (_this.isEditing) {
                _this._onSelect(null);
            }
            var onBlur = _this.props.inputProps.onBlur;
            onBlur && onBlur(event);
        };
        _this._onContentMouseDown = function (e) {
            var onContentMouseDown = _this.props.onContentMouseDown;
            _this.isEditing = false;
            onContentMouseDown && onContentMouseDown(e);
        };
        return _this;
    }
    InputWithOptions.prototype.open = function () {
        // Using getInstance() is here because closeOutside HOC
        this.dropDownRef.getInstance().open();
    };
    InputWithOptions.prototype.close = function () {
        this.dropDownRef.getInstance().close();
    };
    InputWithOptions.prototype._filterOptions = function () {
        var _a = this.props, highlightMatches = _a.highlightMatches, inputProps = _a.inputProps, options = _a.options, filterPredicate = _a.filterPredicate, emptyStateMessage = _a.emptyStateMessage, emptyStateStyle = _a.emptyStateStyle;
        if (!inputProps.value || !this.isEditing) {
            return options;
        }
        var filteredOptions = options.filter(function (option) {
            return (!option.isSelectable && option.value) ||
                (option.isSelectable &&
                    option.value &&
                    filterPredicate(inputProps.value, option.value));
        });
        if (!highlightMatches) {
            return filteredOptions;
        }
        if (emptyStateMessage && filteredOptions.length === 0) {
            return [
                dropdown_option_1.OptionFactory.create({
                    render: function () { return (React.createElement("div", { "data-hook": exports.DataHooks.emptyState, style: emptyStateStyle || {} }, emptyStateMessage)); },
                    isDisabled: true,
                }),
            ];
        }
        return filteredOptions.map(function (option) {
            return option.isSelectable && option.value
                ? dropdown_option_1.OptionFactory.createHighlighted(option, inputProps.value)
                : option;
        });
    };
    InputWithOptions.prototype.render = function () {
        var _this = this;
        var _a = this.props, placement = _a.placement, openTrigger = _a.openTrigger, initialSelectedIds = _a.initialSelectedIds, onInitialSelectedOptionsSet = _a.onInitialSelectedOptionsSet, multi = _a.multi, fixedFooter = _a.fixedFooter, fixedHeader = _a.fixedHeader, timeout = _a.timeout, onDeselect = _a.onDeselect, inputProps = _a.inputProps, forceContentElementVisibility = _a.forceContentElementVisibility, inlineStyles = _a.style, id = _a.id, allowReselect = _a.allowReselect, flip = _a.flip, fixed = _a.fixed, moveBy = _a.moveBy;
        return (React.createElement(dropdown_1.Dropdown, tslib_1.__assign({}, InputWithOptions_st_css_1.default('root', {}, this.props), { placement: placement, openTrigger: openTrigger, disabled: inputProps.disabled, onSelect: this._onSelect, fixedFooter: fixedFooter, fixedHeader: fixedHeader, onDeselect: onDeselect, initialSelectedIds: initialSelectedIds, onInitialSelectedOptionsSet: onInitialSelectedOptionsSet, options: this._filterOptions(), timeout: timeout, multi: multi, role: "combobox", forceContentElementVisibility: forceContentElementVisibility, style: inlineStyles, id: id, ref: function (ref) { return (_this.dropDownRef = ref); }, allowReselect: allowReselect, flip: flip, fixed: fixed, moveBy: moveBy, onContentMouseDown: this._onContentMouseDown }),
            React.createElement(input_1.Input, tslib_1.__assign({ "data-hook": exports.DataHooks.input }, inputProps, { onKeyDown: this._onKeyDown, onFocus: this._onFocus, onBlur: this._onBlur, className: InputWithOptions_st_css_1.default.inputComponent }))));
    };
    InputWithOptions.displayName = 'InputWithOptions';
    InputWithOptions.defaultProps = {
        openTrigger: 'click',
        placement: 'bottom-start',
        multi: false,
        initialSelectedIds: [],
        highlightMatches: true,
        onSelect: function () { return null; },
        onDeselect: function () { return null; },
        onManualInput: function () { return null; },
        onInitialSelectedOptionsSet: function () { return null; },
        filterPredicate: function (inputValue, optionValue) {
            return optionValue.toLowerCase().includes(inputValue.toLowerCase());
        },
    };
    return InputWithOptions;
}(React.PureComponent));
exports.InputWithOptions = InputWithOptions;
//# sourceMappingURL=InputWithOptions.js.map